// Stub for parsePromptTo3DAction — Matilda chat is intentionally NOT brought
// over. The 3D toolbars manipulate scene state directly without NLP parsing,
// so this no-op keeps Creator3D compiling without enabling the chat path.

export type Scene3DAction = unknown;

export async function parsePromptTo3DAction(
  _message: string,
  _sceneContext: unknown,
  _apiKey: string | undefined,
  _model: string
): Promise<Scene3DAction[]> {
  return [];
}
